<template>
    <th
        scope="col"
        class="px-3 py-3.5 first:pl-4 sm:first:pl-3 last:pr-4 sm:last:pr-3 text-base font-medium text-taupe-900"
        :class="[alignmentClasses, hidableClasses]"
    >
        <slot>
            {{ content }}
        </slot>
    </th>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({
    name: 'ZenGridFooterCell',
})

const props = defineProps({
    alignment: {
        type: String,
        required: false,
    },
    hidable: {
        type: Boolean,
        required: false,
        default: true,
    },
    content: {
        type: [String, Number],
        required: false,
    },
})

const alignmentClasses = computed(() => {
    if (props.alignment === 'center') {
        return 'text-center'
    } else if (props.alignment === 'right') {
        return 'text-right'
    } else {
        return 'text-left'
    }
})

const hidableClasses = computed(() => {
    return props.hidable ? 'hidden lg:table-cell' : ''
})
</script>
